import Collection from "../../data-structures/collection"
import TaskType from './task-type'

export default class TaskTypesCollection extends Collection<TaskType> {

    static initFromJson(data:JSONArray):TaskTypesCollection {
        const collection = new TaskTypesCollection([])

        _.map(data, (record:JSONObject)=>{
            collection.add(new TaskType(record))
        })

        return collection
    }

    sort() {
        this.models = _.orderBy(this.models, (model:TaskType) => model.sortPosition)
    }

    filterByCompany(companyId:ID) {
        const companyTaskTypes = new TaskTypesCollection(_.filter(this.models, (model:TaskType) => model.companyId === companyId && !model.isDeleted))
        companyTaskTypes.sort()
        return companyTaskTypes
    }

    resetAndMarkOldModelsAsDeleted(data: any[], companyId?: ID) {
        const previousCollectionModels = _.clone(this.models)

        if (companyId) {
            this.resetByCompany(companyId, data)
        } else {
            const models: TaskType[] = []
            _.map(data, (record:JSONObject)=>{models.push(new TaskType(record))})
            this.reset(models)
        }

        // add models that are missing in new session Collection
        _.map(previousCollectionModels, model => {
            if (!this.get(model.id)) {
                model.isDeleted = true
                this.add(model)
            }
        })
    }

    resetByCompany(companyId:ID, newData:JSONObject[]) {
        const oldTasks = _.filter(this.models, (model:TaskType)=>model.companyId === companyId)

        _.each(oldTasks,model=>{
            this.remove(model.id)
        })

        _.map(newData, (record:JSONObject)=>{
            this.add(new TaskType(record))
        })
    }

    countGenericTaskTypes(companyId:ID) {
        return _.filter(this.models, (model:TaskType)=>model.companyId === companyId && model.settings.isGeneric).length
    }

    exportOptions() {
        return _.filter(this.models, (model:TaskType)=>!model.isDeleted)
            .map(m=>{
                return {
                    value       : m.id,
                    label       : m.name,
                    icon        : m.icon,
                    isGeneric   : m.settings && m.settings.isGeneric
                }
            })
    }

    exportToOptions():Option[] {
        this.sort()
        return _.filter(this.models, (taskType:TaskType)=>!taskType.isDeleted)
            .map((taskType)=>{
                return {
                    value       : taskType.id,
                    label       : taskType.name,
                    icon        : gd.const.ii[taskType.icon],
                }
            })
    }

    reinit() {
        _.map(this.models, (model:TaskType) => {
            _.map(model.statuses?.models, (taskStatus:any) => {
                taskStatus.status = gd.session.statuses.get(taskStatus.statusId)
            })
        })
    }
}